import { DeweySchema } from "routes/root/helpers/brandSchema";

export const CONTEXT_TOKEN_KEY = "contextToken";

export const usesContext = (brand: DeweySchema) => {
  return !!getContextToken() || !!brand.VirtualStore?.companyId;
};

export const getContextToken = () => {
  return sessionStorage.getItem(CONTEXT_TOKEN_KEY) ?? "";
};

export const setContextToken = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get("context_token");
  const localStorageToken = localStorage.getItem(CONTEXT_TOKEN_KEY);
  if (urlToken) {
    localStorage.setItem(CONTEXT_TOKEN_KEY, urlToken);
    sessionStorage.setItem(CONTEXT_TOKEN_KEY, urlToken);
  } else if (localStorageToken) {
    sessionStorage.setItem(CONTEXT_TOKEN_KEY, localStorageToken);
  }
};
